// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"ab897525","732":"ba95c908"}[chunkId] + ".chunk.js";
};